import { Box, Container, Link, MenuItem, Paper, Select, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ProgramTable = ({ items, onSelect, onToggle, nameHeader, title, description, displayClassification, displayStatus, status }) => (
    <Table size="small">
        <caption style={{ captionSide: 'top', color: '#FFFFFF', backgroundColor: '#212529', padding: '12px', textAlign: 'left' }}>
          <div 
            style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '4px' }}
          >
            {title}
            {displayStatus ? 
                <Switch
                  checked={status}
                  onChange={(e) => onToggle("Active Response", e.target.checked)}
                  sx={{ marginLeft: 60 }}
                />                
                : 
                null 
            }
          </div>
          <div style={{ fontSize: '12px', color: '#FFFFFF' }}>{description}</div>
        </caption>
        {status !== false ?
            <>             
                <TableHead>
                    <TableRow sx={{ height: 56, backgroundColor: '#212529' }}>
                        <TableCell sx={{ color: '#e1dddd', fontWeight: 'bold' }}>{nameHeader}</TableCell>
                        <TableCell sx={{ color: '#e1dddd', fontWeight: 'bold' }}>Description</TableCell>
                        {displayClassification ? 
                          <TableCell sx={{ color: '#e1dddd', fontWeight: 'bold' }}>Classification</TableCell>
                        :
                          null
                        }
                        <TableCell sx={{ color: '#e1dddd', fontWeight: 'bold' }}>Activate</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map((item, index) => (
                        <TableRow
                          key={item.id}
                          sx={{ height: 56, backgroundColor: index % 2 === 0 ? '#2c3033' : '#212529' }}
                        >
                            <TableCell sx={{ color: '#e1dddd' }}>{item.name}</TableCell>
                            <TableCell sx={{ color: '#e1dddd' }}>{item.description}</TableCell>
                            {displayClassification ? 
                                <TableCell sx={{ color: 'white', width: '50' }}>{item.classifation}
                                  <Select
                                    sx={{ color: 'white' }}
                                    value={item.classification}
                                    onChange={(e) => onSelect("System Mode", item, e.target.value)}
                                  >
                                    <MenuItem value={'private'}>private</MenuItem>
                                    <MenuItem value={'default'}>default</MenuItem>
                                    <MenuItem value={'none'}>none</MenuItem>
                                  </Select>
                                </TableCell>
                                : 
                                null 
                            } 
                            <TableCell>
                              <Switch
                                checked={!!item.active}
                                onChange={(e) => onToggle(item, e.target.checked)}
                              />
                            </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
            </>
        : null }
      </Table>
);

export default function ProgramSettings() {
  const [options, setOptions] = useState([]);
  const [arActive, setArActive] = useState(false);
  const [activeRespRec, setActiveRespRec] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API}/options/`);
      if (!res.ok) throw new Error('Failed to fetch');
      const response = await res.json();
      const activeResp = response.data.filter(option => option.name === 'Active Response')[0];
      const filteredResp = response.data.filter(item => item.id !== activeResp.id);
      
      setArActive(activeResp.active);
      setActiveRespRec(activeResp);
      setOptions(filteredResp);
      
    } catch (e) {
      console.error(e);
    }
  }

  const handleToggle = async (item, value) => {
    
      if (item === 'Active Response') {
        item = activeRespRec;
        setArActive(value);
      }

      const updatedItem = { ...item, active: value };
      try {
        const res = await fetch(`${process.env.REACT_APP_API}/options/active/${item.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedItem),
        })
        if (res.ok) {
          setOptions((prev) => prev.map((p) => (p.id === item.id ? updatedItem : p)));
          if (updatedItem.active) {
            toast.success(`${updatedItem.name} Activated`);
            fetchOptions();
          } else {
            toast.success(`${updatedItem.name} Deactivated`);
          }
        } else {
          toast.error(`Error: ${res.status}`);
        }
      } catch (e) {
        console.error(e);
      }
  }

  const handleSelect = async (type, item, value) => {
    
      if (type === 'System Mode') {
        const updatedItem = { ...item, classification: value };
        try {
          const res = await fetch(`${process.env.REACT_APP_API}/options/classification/${item.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedItem),
          })
          if (res.ok) {
            setOptions((prev) => prev.map((p) => (p.id === item.id ? updatedItem : p)));
            toast.success(`${updatedItem.name} Classification Set To ${updatedItem.classification}`);
            fetchOptions();
          } else {
            toast.error(`Error: ${res.status}`);
          }
        } catch (e) {
          console.error(e);
        }
      }
  }

  const renderTable = (type, nameHeader, title, description, displayClassification, displayStatus, status, ) => {
    const items = options.filter((item) => item.type === type);
    return (
      <TableContainer
        component={Paper}
        sx={{
          mx: 'auto',
          backgroundColor: 'transparent',
          boxShadow: 'none',
        }}
      >
        <Paper sx={{ backgroundColor: '#1A1A1A' }}>
          <ProgramTable
            items={items}
            onSelect={handleSelect}
            onToggle={handleToggle}
            nameHeader={nameHeader}
            title={title}
            description={description}
            displayClassification={displayClassification}
            displayStatus={displayStatus}
            status={status}
          />
        </Paper>
      </TableContainer>
    );
  };

  const handleApprovedClick = () => {
    navigate('/optionsApprovedList');
  }

  const handleDenyClick = () => {
    navigate('/optionsDenyList');
  }

  const handleRequiredClick = () => {
    navigate('/optionsRequiredList');
  }

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
        <Box sx={{pt: 2}}>
            <ClassificationBannerHeader></ClassificationBannerHeader>
            <PageHeader title="Options"></PageHeader>
        </Box>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '32px', width: '100%', maxwidth: '1600px', margin: '30px auto 0' }}>
            <Stack  sx={{ width: '47%', paddingLeft: 0, marginLeft: 0}} spacing={{ md: 4 }}  >
                {renderTable(
                  'Shippers',
                  'Shippers Systems',
                  'CheckMate Shippers',
                  'Select any data shippers you wish to have installed into your network. You will be given the shipper installs for your hosts.',
                  false,
                  null,
                  null
                )}
                
                {renderTable(
                  'Systems',
                  'System Mode',
                  'System Mode',
                  'Select the mode that you would like this System to run in.',
                  true,
                  null,
                  null
                )}
            </Stack>
            <Stack sx={{ width: '47%'}} >
              {renderTable(
                'Sensors',
                'Sensor Type',
                'CheckMate Sensors',
                'Select any data sensor types so data and configurations can be setup.',
                false,
                null,
                null
              )}
            </Stack>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '32px', width: '95%', maxwidth: '1600px', margin: '30px auto 0' }}>
            {renderTable(
              'Sources',
              'Shippers Systems',
              'Data Sources',
              'This is a list of data sources that may be added to CheckMate. This allows Phen to detect threats and risks from these systems.',
              false,
              null,
              null
            )}
            {renderTable(
              'Response',
              'Shippers Systems',
              'Active Response',
              'This is a list of active responses that may be enabled. This approves Phen.AI to use these settings for making active responses to threats.',
              false,
              'true',
              arActive,
            )}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '32px', width: '95%', maxwidth: '1600px', margin: '30px auto 0' }}>
            {renderTable(
              'Phen',
              'Phen.AI Action',
              'Phen.AI Instructions',
              'Select the actions you want Phen.AI to perform.',
              false,
              null,
              null
            )}
            {renderTable(
              'Manage',
              'Shippers Systems',
              'Systems to Manage',
              'This is a list of systems that will be managed and controlled by Phen. He will be able to take actions to protect these systems from threats.',
              false,
              null,
              null
            )}
          </Box>
            
          <Typography display="block" sx={{ display: 'flex', justifyContent: 'left', gap: '32px', width: '95%', margin: '10px auto 0', mt: 2, '&:hover': { cursor: 'pointer' } }}>
                <Link underline="hover" color="#c1d4e7" onClick={handleApprovedClick}>
                    Application Approved List
                </Link>
                :: List of maintained applications that are pre authorized.                
          </Typography>
          
          <Typography display="block" sx={{ display: 'flex', justifyContent: 'left', gap: '60px', width: '95%', margin: '5px auto 0', '&:hover': { cursor: 'pointer' } }}>
                <Link underline="hover" color="#c1d4e7" onClick={handleDenyClick}>
                  Application Deny List
                </Link>
                :: List of applications that should be removed.
          </Typography>
          <Typography display="block" sx={{ display: 'flex', justifyContent: 'left', gap: '32px', width: '95%', margin: '5px auto 0', '&:hover': { cursor: 'pointer' } }}>
                <Link underline="hover" color="#c1d4e7" onClick={handleRequiredClick}>
                  Application Required List
                </Link>
                :: List of applications that should not be removed.
          </Typography>
        </Box>
    </Container>
  );
}
